module.exports = __webpack_public_path__ + "img/italy.cc79b186.png";